(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-mystery-gift"]) return;
  try {
    
  (() => {
    const dialog = document.getElementById('BfMysteryGift');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
    const write = (key, value) => { try { localStorage.setItem(key, String(value)); } catch {} };
    const scratch = dialog.querySelector('[data-gift-scratch]');
    const email = dialog.querySelector('[data-gift-email]');
    const canvas = dialog.querySelector('canvas');
    const context = canvas.getContext('2d', { willReadFrequently:true });
    const preview = new URLSearchParams(location.search).get('bf_gift_preview') === '1';
    let reward = Number(read('bf_mystery_reward_v1'));
    if (reward !== 10 && reward !== 20) {
      const random = new Uint32Array(1);
      do { crypto.getRandomValues(random); } while (random[0] >= 4294967200);
      reward = random[0] % 100 === 0 ? 20 : 10;
      write('bf_mystery_reward_v1', reward);
    }
    dialog.querySelector('[data-gift-tags]').value = 'newsletter,bf_mystery,bf_scratch_' + reward;
    let revealed = false, revealPending = false;
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      scratch.hidden = true;
      email.hidden = false;
      if (dialog.dataset.ready === 'true') dialog.querySelector('input[type=email]').focus();
    };
    const close = () => { write('bf_mystery_dismissed_v1', Date.now()); dialog.close(); };
    dialog.querySelector('.bf-gift__close').addEventListener('click', close);
    dialog.addEventListener('cancel', () => write('bf_mystery_dismissed_v1', Date.now()));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) close(); } });
    dialog.querySelector('.bf-gift__reveal').addEventListener('click', reveal);
    // Native modal dialogs otherwise cover Shopify's human-verification challenge.
    // Leave Shopify's submission and CAPTCHA validation intact.
    const giftForm = dialog.querySelector('form');
    const releaseModalForSubmission = () => {
      if (dialog.dataset.ready === 'true' && giftForm.checkValidity()) dialog.close();
    };
    giftForm.addEventListener('submit', releaseModalForSubmission, true);
    giftForm.querySelector('[type=submit]').addEventListener('click', releaseModalForSubmission);
    if (context) {
      const fill = context.createLinearGradient(0,0,600,300);
      fill.addColorStop(0,'#e9d392'); fill.addColorStop(.4,'#d9bc70'); fill.addColorStop(.55,'#f1dfa2'); fill.addColorStop(1,'#c8a65e');
      context.fillStyle=fill; context.fillRect(0,0,600,300);
      context.fillStyle='#fff9e5'; context.font='600 32px Arial'; context.textAlign='center'; context.fillText(canvas.dataset.label,300,163);
      for(let i=0;i<24;i++){ context.beginPath(); context.arc((i*173+31)%600,(i*97+15)%300,1.5,0,Math.PI*2); context.fill(); }
      context.globalCompositeOperation='destination-out'; context.lineWidth=72; context.lineCap='round'; context.lineJoin='round';
      let dragging=false, previous=null, movements=0;
      const point=e=>{const r=canvas.getBoundingClientRect();return {x:(e.clientX-r.left)*600/r.width,y:(e.clientY-r.top)*300/r.height};};
      const erase=e=>{if(!dragging||revealed||revealPending)return; const p=point(e);context.beginPath();context.moveTo(previous?.x??p.x,previous?.y??p.y);context.lineTo(p.x,p.y);context.stroke();previous=p;if(++movements%8===0){const pixels=context.getImageData(0,0,600,300).data;let clear=0,total=0;for(let i=3;i<pixels.length;i+=160){total++;if(pixels[i]<128)clear++;}if(clear/total>.80&&!revealPending){revealPending=true;context.clearRect(0,0,600,300);setTimeout(()=>{if(dialog.open)reveal();},1100);}}};
      canvas.addEventListener('pointerdown',e=>{dragging=true;previous=point(e);canvas.setPointerCapture(e.pointerId);erase(e);});
      canvas.addEventListener('pointermove',erase);
      const stop=()=>{dragging=false;previous=null;};canvas.addEventListener('pointerup',stop);canvas.addEventListener('pointercancel',stop);
    }
    const succeeded=dialog.querySelector('[data-gift-success]');
    const failed=dialog.querySelector('[data-gift-error]');
    if (succeeded) { write('bf_mystery_claimed_v1','true'); reveal(); dialog.querySelector('input[type=email]').hidden=true;dialog.querySelector('.bf-gift__submit').hidden=true;dialog.showModal(); }
    else if(failed){reveal();dialog.showModal();}
    else if(preview||(!read('bf_mystery_claimed_v1')&&Date.now()-Number(read('bf_mystery_dismissed_v1'))>86400000)){
      const delay = Math.max(0, Number(dialog.dataset.delay) * 1000 - performance.now());
      const openWhenAvailable = () => {
        if (dialog.open) return;
        if (document.hidden || document.querySelector('dialog[open]')) { setTimeout(openWhenAvailable, 500); return; }
        dialog.showModal();
      };
      setTimeout(openWhenAvailable, delay);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
